export default __webpack_public_path__ + "static/media/Version (2) - Prisoner of Azkaban_19.2cba236c.jpg";